import { AuthenticationResult, EventType, PublicClientApplication } from '@azure/msal-browser';
import authConfig from './authConfig';

const msalInstance = new PublicClientApplication(authConfig);

// msal-browser v3+ requires initialize() to resolve before any other MSAL API
// (including getActiveAccount()/getAllAccounts()) is called. Callers must await
// this before rendering MsalProvider.
export const initializeMsal = async () => {
  await msalInstance.initialize();

  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }
};

msalInstance.addEventCallback((e) => {
  switch (e.eventType) {
    case EventType.LOGIN_SUCCESS:
    case EventType.ACQUIRE_TOKEN_SUCCESS: {
      // LOGIN_SUCCESS's payload doesn't always carry an account (observed
      // empty on the redirect flow, where ACQUIRE_TOKEN_SUCCESS fires first
      // WITH one) — setActiveAccount(undefined) clears whatever was just set,
      // dropping the freshly-authenticated user back to "no active account"
      // and permanently stalling the app on the loading screen right after
      // login. Only ever set an account we actually received.
      const { account } = e.payload as AuthenticationResult;
      if (account) {
        msalInstance.setActiveAccount(account);
      }
      break;
    }
    // msal-browser v5 replaced LOGIN_FAILURE/ACCOUNT_REMOVED with
    // ACQUIRE_TOKEN_FAILURE/LOGOUT_SUCCESS respectively (account storage
    // events, including cross-tab account removal, are now folded into these).
    case EventType.ACQUIRE_TOKEN_FAILURE:
      msalInstance.loginRedirect();
      break;
    case EventType.LOGOUT_SUCCESS:
      msalInstance.logoutRedirect({
        account: msalInstance.getActiveAccount(),
      });
      break;
    default:
      break;
  }
});

if (window) {
  const handleStorageEvent = (e: StorageEvent) => {
    if (e.key === 'logout-event' && e.newValue === 'started') {
      msalInstance.logoutRedirect({
        account: msalInstance.getActiveAccount(),
      });
    }
  };

  window.addEventListener('storage', handleStorageEvent);
}

export default msalInstance;
